import { performFullScreening } from '../utils/callVeriffApi';

export const CALL_VERIFF_API = Symbol('callVeriffApi key');

/**
 * Redux middleware for Veriff AML API calls
 * Intercepts actions with CALL_VERIFF_API symbol and performs AML screening
 */
const callVeriffApi = store => next => async (action) => {
    const veriffAction = action[CALL_VERIFF_API];

    // If it's not a Veriff API action, skip to next middleware
    if (typeof veriffAction === 'undefined') {
        return next(action);
    }

    const state = store.getState();
    const env = state.appstate?.environment || 'staging';
    const { types, personData, screeningType, ownerIndex } = action;

    // Dispatch request action
    next({ type: types[0], screeningType, ownerIndex });

    try {
        // Perform the full screening flow
        const result = await performFullScreening(env, personData);

        // Dispatch success action with results
        return next({
            type: types[1],
            data: result,
            screeningType,
            ownerIndex
        });
    } catch (error) {
        // Dispatch failure action
        return next({
            type: types[2],
            error: error.message || 'AML screening failed',
            screeningType,
            ownerIndex
        });
    }
};

export default callVeriffApi;
